import { useMemo, useState } from "react";
import { archives } from "@/mocks/expose";

const statusStyle: Record<string, string> = {
  已实锤: "bg-primary-100 text-primary-700",
  进行中: "bg-accent-100 text-accent-800",
  待验证: "bg-secondary-100 text-secondary-900",
  辟谣反转: "bg-background-200 text-foreground-500",
};

export default function ArchiveModule() {
  const [tag, setTag] = useState("全部");
  const [kw, setKw] = useState("");

  const tags = useMemo(() => ["全部", ...Array.from(new Set(archives.map((a) => a.tag)))], []);

  const list = archives.filter(
    (a) => (tag === "全部" || a.tag === tag) && a.title.includes(kw.trim())
  );

  return (
    <section id="archive" className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            <i className="ri-archive-drawer-line text-base"></i>
            Archive · 未公开信息深挖档案
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            每一次深挖，都留档可查
          </h2>
        </div>
        <label className="relative">
          <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
          <input
            type="text"
            value={kw}
            onChange={(e) => setKw(e.target.value)}
            placeholder="在档案中检索线索"
            className="w-52 rounded-md border border-background-200 bg-background-100 py-2 pl-9 pr-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50 sm:w-64"
          />
        </label>
      </div>

      <div className="mt-5 flex flex-wrap gap-2">
        {tags.map((t) => (
          <button
            key={t}
            type="button"
            onClick={() => setTag(t)}
            className={`whitespace-nowrap rounded-full border px-3.5 py-1.5 text-sm transition-colors ${
              tag === t
                ? "border-primary-500 bg-primary-500 font-medium text-background-50"
                : "border-background-300 bg-background-50 text-foreground-600 hover:border-foreground-400"
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      <p className="mt-4 text-xs text-foreground-500">
        共 {list.length} 条档案 · 按结案时间倒序 · 状态实时更新
      </p>

      {/* 档案行：上窄下密的桌面表格形态 */}
      <div className="mt-4 overflow-hidden rounded-lg border border-background-200/80">
        <div className="hidden grid-cols-12 gap-4 border-b border-background-200 bg-background-100 px-5 py-3 text-xs font-semibold text-foreground-500 md:grid">
          <span className="col-span-2">结案日期</span>
          <span className="col-span-2">方向</span>
          <span className="col-span-5">深挖标题</span>
          <span className="col-span-2">状态</span>
          <span className="col-span-1 text-right">热度</span>
        </div>
        {list.map((a) => (
          <div
            key={a.title}
            className="grid grid-cols-1 gap-2 border-b border-background-100 px-5 py-4 transition-colors last:border-0 hover:bg-background-50 md:grid-cols-12 md:items-center md:gap-4"
          >
            <span className="text-sm text-foreground-500 md:col-span-2">{a.time}</span>
            <span className="md:col-span-2">
              <span className="rounded bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600">
                {a.tag}
              </span>
            </span>
            <span className="font-heading text-[15px] font-semibold leading-6 text-foreground-900 md:col-span-5">
              {a.title}
            </span>
            <span className="md:col-span-2">
              <span
                className={`inline-block rounded px-2 py-0.5 text-[11px] font-semibold ${statusStyle[a.status]}`}
              >
                {a.status}
              </span>
            </span>
            <span className="flex items-center gap-1 text-xs text-foreground-500 md:col-span-1 md:justify-end">
              <i className={a.hot ? "ri-fire-line text-accent-600" : "ri-fire-line text-foreground-300"}></i>
              {a.hot ? "高热" : "常"}
            </span>
          </div>
        ))}
        {list.length === 0 && (
          <p className="px-5 py-10 text-center text-sm text-foreground-500">
            未找到匹配的档案，换个关键词试试。
          </p>
        )}
      </div>

      <div className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
        <i className="ri-lock-line text-accent-600"></i>
        涉密与个人敏感信息仅保留可公开交叉验证的部分；无法复核的内容一律不入档。
      </div>
    </section>
  );
}